import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { Box, styled } from "@mui/material";

export const EditorContainer = styled(Box)({
  width: "100%",
  minWidth: "100%",
  maxWidth: "100%",
  margin: 0,
  borderRadius: "2px",
  color: "#000",
  position: "relative",
  lineHeight: "20px",
  fontWeight: 400,
  textAlign: "left",
  borderTopLeftRadius: "10px",
  borderTopRightRadius: "10px",
  border: "1px solid #ddd",
  boxSizing: "border-box",
  flex: "1 1 100%",
});

export const InnerEditor = styled(Box)({
  background: "#fff",
  position: "relative",
});

export const PlaceHolder = styled(Box)({
  color: "#999",
  overflow: "hidden",
  position: "absolute",
  textOverflow: "ellipsis",
  top: 0,
  left: "10px",
  fontSize: "15px",
  userSelect: "none",
  display: "inline-block",
  pointerEvents: "none",
});

export const MuiContentEditable = styled(ContentEditable)({
  resize: "none",
  fontSize: "15px",
  caretColor: "rgb(5, 5, 5)",
  position: "relative",
  tabSize: 1,
  outline: 0,
  padding: "0 10px",
  minHeight: "150px",

  "& .editor-mention": {
    display: "inline",
    padding: "1px 4px",
    margin: "0 1px",
    backgroundColor: "transparent",
    border: "1px solid transparent",
    borderRadius: "2px",
    fontSize: "13px",
    lineHeight: 1.2,
    color: "#0052cc",
    fontWeight: 400,
    transition: "all 0.1s ease-in-out",
    textDecoration: "none",
    "&:hover": {
      backgroundColor: "rgba(0, 82, 204, 0.08)",
      borderColor: "rgba(0, 82, 204, 0.2)",
    },
  },

  "& .editor-mention-focused": {
    display: "inline",
    padding: "1px 4px",
    margin: "0 1px",
    backgroundColor: "rgba(0, 82, 204, 0.08)",
    border: "1px solid rgba(0, 82, 204, 0.2)",
    borderRadius: "2px",
    fontSize: "13px",
    lineHeight: 1.2,
    color: "#0052cc",
    fontWeight: 400,
    transition: "all 0.1s ease-in-out",
    textDecoration: "none",
  },

  "& .editor-text-bold": {
    fontWeight: "bold",
  },

  "& .editor-text-italic": {
    fontStyle: "italic",
  },

  "& .editor-text-underline": {
    textDecoration: "underline",
  },

  "& .editor-text-strikethrough": {
    textDecoration: "line-through",
  },

  "& .editor-text-underlineStrikethrough": {
    textDecoration: "underline line-through",
  },

  "& .editor-text-code": {
    backgroundColor: "#f4f4f4",
    border: "1px solid #e0e0e0",
    borderRadius: "3px",
    padding: "1px 3px",
    fontFamily: '"Courier New", Courier, monospace',
    fontSize: "0.9em",
  },

  "& .editor-text-hashtag": {
    color: "#0052cc",
    fontWeight: 500,
  },

  "& .editor-text-overflowed": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
});

export const ReadOnlyEditorContainer = styled(Box)({
  backgroundColor: "transparent",
  border: "none",
  boxShadow: "none",
  width: "100%",
  minWidth: "100%",
  maxWidth: "100%",
  boxSizing: "border-box",
});

export const ReadOnlyInnerEditor = styled(Box)({
  background: "transparent",
  borderRadius: "8px",
  position: "relative",
});

export const ReadOnlyContentEditable = styled(ContentEditable)({
  minHeight: "auto",
  background: "transparent",
  border: "none",
  cursor: "default",
  color: "#333",
  lineHeight: "1.5",
  fontSize: "14px",
  resize: "none",
  position: "relative",
  tabSize: 1,
  outline: 0,
  padding: 0,
  paddingLeft: 4,

  "& .editor-mention": {
    display: "inline",
    padding: "1px 4px",
    margin: "0 1px",
    backgroundColor: "transparent",
    border: "1px solid transparent",
    borderRadius: "2px",
    fontSize: "13px",
    lineHeight: 1.2,
    color: "#0052cc",
    fontWeight: 400,
    textDecoration: "none",
  },

  "& .editor-text-bold": {
    fontWeight: "bold",
  },

  "& .editor-text-italic": {
    fontStyle: "italic",
  },

  "& .editor-text-underline": {
    textDecoration: "underline",
  },

  "& .editor-text-strikethrough": {
    textDecoration: "line-through",
  },

  "& .editor-text-underlineStrikethrough": {
    textDecoration: "underline line-through",
  },

  "& .editor-text-code": {
    backgroundColor: "#f4f4f4",
    border: "1px solid #e0e0e0",
    borderRadius: "3px",
    padding: "1px 3px",
    fontFamily: '"Courier New", Courier, monospace',
    fontSize: "0.9em",
  },

  "& .editor-text-hashtag": {
    color: "#0052cc",
    fontWeight: 500,
  },

  "& .editor-text-overflowed": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  "& p:last-of-type": {
    marginBottom: 0,
  },
});
